import React from 'react';

export const AssignmentTaskCover: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      width='252'
      height='225'
      viewBox='0 0 252 225'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M124.594 207.03C169.403 207.03 205.903 179.035 207.594 144.03H41.5938C43.2849 179.033 79.8036 207.03 124.594 207.03Z'
        fill='#2E2945'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M39.7856 142H210.518C211.5 142 212.304 142.8 212.304 143.755C212.304 144.71 211.502 145.491 210.518 145.491H39.7856C38.8036 145.491 38 144.712 38 143.755C38 142.798 38.8015 142 39.7856 142Z'
        fill='#443D67'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21.8901 154.57C24.0365 154.57 25.7801 152.873 25.7801 150.784C25.7801 148.694 24.0344 147 21.8901 147C19.7457 147 18 148.697 18 150.784C18 152.871 19.7457 154.57 21.8901 154.57Z'
        fill='#443D67'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M228.892 111.568C231.039 111.568 232.782 109.871 232.782 107.784C232.782 105.697 231.039 104 228.892 104C226.746 104 225 105.697 225 107.784C225 109.871 226.746 111.568 228.892 111.568Z'
        fill='#B7AEE2'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M37.8922 77.5677C40.0386 77.5677 41.7822 75.8711 41.7822 73.7838C41.7822 71.6966 40.0386 70 37.8922 70C35.7457 70 34 71.6966 34 73.7838C34 75.8711 35.7457 77.5677 37.8922 77.5677Z'
        fill='#B7AEE2'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M209.945 63.7859C211.007 63.7859 211.89 62.9272 211.89 61.8929C211.89 60.8587 211.007 60 209.945 60C208.883 60 208 60.8587 208 61.8929C208 62.9272 208.883 63.7859 209.945 63.7859Z'
        fill='#B7AEE2'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M211.437 189.908C213.583 189.908 215.327 188.211 215.327 186.122C215.327 184.032 213.583 182.338 211.437 182.338C209.29 182.338 207.547 184.034 207.547 186.122C207.547 188.209 209.29 189.908 211.437 189.908Z'
        fill='white'
        fillOpacity='0.5'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M188.592 183.154C173.406 197.731 150.527 207.03 124.924 207.03C99.322 207.03 76.4432 197.729 61.257 183.154C51.4673 172.441 63.0502 156.176 75.4397 164.161C93.5484 175.837 137.188 204.147 188.594 183.154H188.592Z'
        fill='#443D67'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M170.945 33.765C172.009 33.765 172.89 32.9272 172.89 31.8721C172.89 30.8169 172.009 30 170.945 30C169.881 30 169 30.8378 169 31.8721C169 32.9063 169.881 33.765 170.945 33.765Z'
        fill='#443D67'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M71.945 206.765C73.0088 206.765 73.8901 205.927 73.8901 204.872C73.8901 203.817 73.0088 203 71.945 203C70.8812 203 70 203.838 70 204.872C70 205.906 70.8812 206.765 71.945 206.765Z'
        fill='#443D67'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M111.89 33.5676C114.037 33.5676 115.78 31.8711 115.78 29.7838C115.78 27.6966 114.037 26 111.89 26C109.744 26 108 27.6966 108 29.7838C108 31.8711 109.744 33.5676 111.89 33.5676Z'
        fill='white'
        fillOpacity='0.3'
      />
      <path
        d='M138.324 84.192H99.2975C98.731 84.192 98.2715 83.7344 98.2715 83.1682C98.2715 82.602 98.731 82.1465 99.2975 82.1465H138.324C138.893 82.1465 139.352 82.6041 139.352 83.1682C139.352 83.7323 138.893 84.192 138.324 84.192Z'
        fill='#B7AEE2'
      />
      <path
        d='M123.945 89.3072H99.2975C98.731 89.3072 98.2715 88.8496 98.2715 88.2834C98.2715 87.7172 98.731 87.2617 99.2975 87.2617H123.945C124.514 87.2617 124.973 87.7193 124.973 88.2834C124.973 88.8475 124.514 89.3072 123.945 89.3072Z'
        fill='#B7AEE2'
      />
      <rect x='79' y='60' width='98' height='98' rx='16' fill='#E8E4F9' />
      <path
        d='M152.847 100.68C154.051 99.4762 154.051 97.524 152.847 96.3198C151.643 95.1157 149.691 95.1157 148.486 96.3198L122.25 122.556L111.514 111.82C110.309 110.616 108.357 110.616 107.153 111.82C105.949 113.024 105.949 114.976 107.153 116.18L120.07 129.097C121.274 130.301 123.226 130.301 124.43 129.097L152.847 100.68Z'
        fill='#2E2945'
        stroke='#2E2945'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default AssignmentTaskCover;
